import React, { Component } from 'react';

function withMediaQuery(query) {
  return function wrapWithMediaQuery(WrappedComponent) {
    return class MediaQuery extends Component {
      constructor(props) {
        super(props);
        this.state = { matches: window.matchMedia(query).matches };
      }

      componentDidMount() {
        this.mediaQueryList = window.matchMedia(query);
        this.listener = event => {
          this.setState({ matches: event.matches });
        };
        this.mediaQueryList.addEventListener('change', this.listener);
      }

      componentWillUnmount() {
        this.mediaQueryList.removeEventListener('change', this.listener);
      }

      render() {
        return (
          <WrappedComponent
            {...this.props}
            matchesBreakpoint={this.state.matches}
          />
        );
      }
    };
  };
}

export default withMediaQuery;
